const gql = {
  query: `mutation DeleteContact($deleteContact: Security2FAContact!){
      deleteContact(input: $deleteContact)
  }`,
  variables: {
    deleteContact: {
      id: null,
      notifications: null,
      type: null,
      value: null,
    },
  },
  meta: {
    label: "Delete MFA Contact",
  },
};

export default gql;
